<div class="filter-header-container">
  @if (icon) {
    <span style="margin-right: 4px" [class]="icon"></span>
  }
  <span>
    {{ label.length > 0 ? label + ': ' : '' }}
  </span>
  <div
    class="CssFilterItemHeader p-multiselect p-component CssVerticalAlignMiddle {{
      disabledElement ? 'p-disabled' : ''
    }} {{ isFocus ? divFocusClass : '' }}"
    [ngClass]="btnTarget.classList.contains('focus-visible') ? divFocusClass : ''"
    tabindex="0"
    (click)="onClickAction($event)"
    (keyup.enter)="onClickAction($event)"
    [style.visibility]="hideButton ? 'hidden' : 'visible'"
  >
    <div class="p-multiselect-label-container" [title]="customTitle ? customTitle : title">
      <button
        #btnTarget
        type="button"
        class="p-multiselect-label p-component CssHeaderLabel
                       {{ ixDeleteClick.observed ? 'CssHeaderLabelWithClose' : '' }}
                       {{ isSelected() ? 'CssfilterBold' : '' }}
                       {{ buttonClass }}"
        (focus)="onFocus($event)"
        (focusout)="onFocusOut()"
      >
        <span [style.color]="isSelected() ? 'black' : '#737373'">
          {{ displayText }}
        </span>
        <!-- Used when setting custom focus to component -->
        @if (divFocusClass !== '') {
          <span
            class="p-multiselect-trigger"
            style="width: auto; border: 0"
            [style.background-color]="angleDefaultAction ? 'inherit' : ''"
          >
            @if (showDropdownButton && !disabledElement) {
              <span
                tabindex="0"
                #angleDown
                class="pi pi-fw pi-angle-down p-clickable CssFilterItemHeaderButton"
                [ngClass]="{ primaryColor: activeAngleDown }"
                (keyup.enter)="onClickDown($event)"
                (click)="onClickDown($event)"
              >
              </span>
            }
            @if (ixDeleteClick.observed && !disabledElement) {
              <span
                #deleteButton
                class="pi pi-fw pi-times p-clickable CssFilterItemHeaderButton CssCloseFilter"
                style="margin-right: 5px; padding-left: 0"
                tabindex="0"
                (keyup.enter)="ixDeleteClick.emit($event)"
                (click)="ixDeleteClick.emit($event)"
              >
              </span>
            }
          </span>
        }
      </button>
    </div>
    <!-- Used when setting custom focus to component -->
    @if (divFocusClass === '') {
      <span
        class="p-multiselect-trigger"
        style="width: auto; border: 0"
        [style.background-color]="angleDefaultAction ? 'inherit' : ''"
      >
        @if (showDropdownButton && !disabledElement) {
          <span
            tabindex="0"
            #angleDown
            class="pi pi-fw pi-angle-down p-clickable CssFilterItemHeaderButton"
            [ngClass]="{ primaryColor: activeAngleDown }"
            (keyup.enter)="onClickDown($event)"
            (click)="onClickDown($event)"
          >
          </span>
        }
        @if (ixDeleteClick.observed && !disabledElement) {
          <span
            #deleteButton
            class="pi pi-fw pi-times p-clickable CssFilterItemHeaderButton CssCloseFilter"
            style="margin-right: 5px; padding-left: 0"
            tabindex="0"
            (click)="ixDeleteClick.emit($event)"
            (keyup.enter)="ixDeleteClick.emit($event)"
          >
          </span>
        }
      </span>
    }
  </div>
</div>
